// @flow
import { makeApiCall } from '../../../../services/apiService/apiService';

export const retailCashbookActions = {
  SET_RTL_CASHBOOK_DATE_FILTER: 'SET_RTL_CASHBOOK_DATE_FILTER',
  GET_COLLECTIONS_CASHBOOK: 'GET_COLLECTIONS_CASHBOOK',
  FILTER_CASHBOOK_TABLE_DATA: 'FILTER_CASHBOOK_TABLE_DATA',
  OPEN_HANDOVER_TRANSACTION_MODAL: 'OPEN_HANDOVER_TRANSACTION_MODAL',
  GET_OVERALL_OUTSTANDING: 'GET_OVERALL_OUTSTANDING'
};

export const openHandoverTransactionModal = val => ({
  type: retailCashbookActions.OPEN_HANDOVER_TRANSACTION_MODAL,
  payload: val
});

export const setDateFilter = (startDate = false, endDate = false) => ({
  type: retailCashbookActions.SET_RTL_CASHBOOK_DATE_FILTER,
  payload: { startDate, endDate }
});

export const filterTableData = (filterObj: Object) => ({
  type: retailCashbookActions.FILTER_CASHBOOK_TABLE_DATA,
  payload: filterObj
});

export const getCollectionsCashbookAction = (obj: Object) => ({
  type: retailCashbookActions.GET_COLLECTIONS_CASHBOOK,
  payload: obj
});

export const getCollectionsCashbook = retailCashbookState => (
  dispatch: Function
) => {
  dispatch(
    getCollectionsCashbookAction({
      isLoading: true,
      isLoaded: false,
      tableData: null,
      tableDataFiltered: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getCollectionsCashbook',
    replaceParamsArr: [
      { key: 'fromDate', val: retailCashbookState.filterValues.startDate },
      { key: 'toDate', val: retailCashbookState.filterValues.endDate }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched Retail Cashbook Details ', res);
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          tableData: res.payload,
          tableDataFiltered: res.payload
        };
        dispatch(getCollectionsCashbookAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCollectionsCashbookAction({
            isLoading: false,
            isLoaded: true,
            tableData: [],
            tableDataFiltered: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching retail cashbook, res= ', res);
      dispatch(
        getCollectionsCashbookAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching retail cashbook', res);
      dispatch(
        getCollectionsCashbookAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getOverallOutstandingAction = (obj: Object) => ({
  type: retailCashbookActions.GET_OVERALL_OUTSTANDING,
  payload: obj
});

export const getOverallOutstanding = () => (dispatch: Function) => {
  dispatch(
    getCollectionsCashbookAction({
      isLoading: true,
      isLoaded: false,
      overallOutstanding: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getOverallOutstanding',
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched Overall Outstanding ', res);
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          overallOutstanding: res.payload
        };
        dispatch(getOverallOutstandingAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCollectionsCashbookAction({
            isLoading: false,
            isLoaded: true,
            overallOutstanding: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching overall Outstanding, res= ', res);
      dispatch(
        getCollectionsCashbookAction({
          isLoading: false,
          isLoaded: true,
          overallOutstanding: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching overall Outstanding', res);
      dispatch(
        getCollectionsCashbookAction({
          isLoading: false,
          isLoaded: true,
          overallOutstanding: null
        })
      );
    }
  };

  return makeApiCall(requestObj);
};
